import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApolloClient, gql, NormalizedCacheObject } from "@apollo/client";
import { RootState } from "@src/redux/store";

const GRAPHQL = gql`
  query IntrospectionQuery {
    schema: __schema {
      types {
        name
        fields {
          name
        }
      }
    }
  }
`;
interface types {
  result: any;
  loading: boolean;
  error: any;
}
const initialState: types = {
  result: null,
  loading: false,
  error: null
};

export const schemaRequest = createAsyncThunk<
  types,
  {},
  {extra: ApolloClient<NormalizedCacheObject>;}>(
  "system_user/schema", async (params: {}, { extra: client }) => {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.schema;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || "An error occurred",
        statusCode: err.statusCode || "500"
      });
    }
  });

const schemaSlice = createSlice({
  name: "schema",
  initialState: initialState,
  reducers: {
    schemaClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(schemaRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(schemaRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(schemaRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: "Failed to fetch",
        statusCode: "500"
      };
      state.loading = false;
    });
  }
});

export const { schemaClear } = schemaSlice.actions;

export const schema = (state: RootState) => ({
  result: state.schema.schema.result,
  error: state.schema.schema.error,
  loading: state.schema.schema.loading
});

export default schemaSlice.reducer;